<template>
    <div class="m-2">
        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Название</span>
            <span class="w-2/3">
               {{ entity.title }}
            </span>
        </div>
        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Активен</span>
            <span class="w-2/3">
                <CBadge :color="entity.enabled ? 'success' : 'secondary'">
                    {{ entity.enabled ? "Да" : "Нет" }}
                </CBadge>
            </span>
        </div>
        
        <!-- Автоматическая активация -->
        <div v-if="entity.auto_activate" class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Автоактивация</span>
            <span class="w-2/3">
                <CBadge color="success">
                    {{ getConditionLabel(entity.auto_activate_condition) }} {{ entity.auto_activate_threshold }} {{ getOrdersWord(entity.auto_activate_threshold) }}
                </CBadge>
            </span>
        </div>
        
        <!-- Автоматическая деактивация -->
        <div v-if="entity.auto_deactivate" class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Автодеактивация</span>
            <span class="w-2/3">
                <CBadge color="danger">
                    {{ getConditionLabel(entity.auto_deactivate_condition) }} {{ entity.auto_deactivate_threshold }} {{ getOrdersWord(entity.auto_deactivate_threshold) }}
                </CBadge>
            </span>
        </div>
        
        <div class="mt-4 px-0">
            <DemandShedule 
                :entity-id="entity.id"
                :schedule-list="entity.schedules"
                :only-show="true"
            />
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    const { formatDate } = require('../../utils/views');
    import DemandShedule from './DemandShedule';

    export default {
        components: {
            DemandShedule,
        },
        props: {
            entity: {
                type: Object,
                default: () => {},
            },
        },
        methods: {
            getConditionLabel(condition) {
                const labels = {
                    'more_than': 'Больше или равно',
                    'less_than': 'Строго меньше'
                };
                return labels[condition] || condition;
            },
            getOrdersWord(count) {
                // Склонение слова "заказ"
                const lastDigit = count % 10;
                const lastTwoDigits = count % 100;
                
                if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
                    return 'заказов';
                }
                
                if (lastDigit === 1) {
                    return 'заказ';
                }
                
                if (lastDigit >= 2 && lastDigit <= 4) {
                    return 'заказа';
                }
                
                return 'заказов';
            }
        }
    };
</script>
